import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

// import "./pricing.css";
function NewPricing() {
  const [openRowLead, setOpenRowLead] = useState(false);
  const [openRowSales, setOpenRowSales] = useState(false);
  const [openRowUsers, setOpenRowUsers] = useState(false);
  const [openRowAutomation, setOpenRowAutomation] = useState(false);
  const [openRowReport, setOpenRowReport] = useState(false);
  // const [openRowPlatform, setOpenRowPlatform] = useState(false);
  const [openRowProdAddOn, setOpenRowProdAddOn] = useState(false);
  const [openRowMobCrm, setOpenRowMobCrm] = useState(false);
  const stickySectionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  const navigate = useNavigate();

  const handleExpand = (e) => {
    const newvalue = e.target.checked;

    setOpenRowLead(!openRowLead);
    setOpenRowSales(!openRowSales);
    setOpenRowUsers(!openRowUsers);
    setOpenRowAutomation(!openRowAutomation);
    setOpenRowReport(!openRowReport);
    setOpenRowProdAddOn(!openRowProdAddOn);
    setOpenRowMobCrm(!openRowMobCrm);

    if (!newvalue) {
      window.scrollTo({
        behavior: "smooth",
        top: 200,
      });
    }
  };

  return (
    <>
      <div className="breadcrumb-bar text-center">
        <div className="container2">
          <div className="row">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title mb-2">Pricing</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link style={{ textDecoration: "none" }} to="/">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Pricing
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div id="top">
        <div id="main" className="all_colors" data-scroll-offset={70}>
          <div
            id="av_section_1"
            className="avia-section no-lazyload-section av-1hmqzrs2d-77c1d5375906c0f05bff615e8c0b6588 main_color avia-section no-lazyload-section-default avia-no-border-styling avia-builder-el-0 el_before_av_section avia-builder-el-first pricing-header-hide avia-bg-style-scroll container_wrap fullsize"
          >
            <div className="container2 av-section-cont-open">
              <main
                role="main"
                itemProp="mainContentOfPage"
                className="template-page content av-content-full alpha units"
              >
                <div
                  style={{
                    position: "relative",
                  }}
                  className="post-entry post-entry-type-page post-entry-3174"
                >
                  <div className="entry-content-wrapper clearfix">
                    <div className="flex_column av-8o2rzdh-603e4882841bfb346b72c9ac36b19880 av_one_full avia-builder-el-1 el_before_av_one_third avia-builder-el-first first flex_column_div ">
                      <div className="av-special-heading av-1jkop5lg5-06bdcfac9c6ed17c608e9fbee1456a2c av-special-heading-h1 blockquote modern-quote modern-centered avia-builder-el-2 avia-builder-el-no-sibling ">
                        <h1
                          style={{ color: "#020202ff" }}
                          className="av-special-heading-tag "
                          itemProp="headline"
                        >
                          Sales CRM Pricing
                        </h1>
                        <div className="av-subheading av-subheading_below">
                          <p>
                            All the tools you need for high sales efficiency.
                          </p>
                        </div>
                        <div className="special-heading-border">
                          <div className="special-heading-inner-border" />
                        </div>
                      </div>
                    </div>
                    <div
                      ref={stickySectionRef}
                      style={{
                        position: "sticky",
                        top: "-200px",
                        zIndex: "999",
                      }}
                      className={`flex_column_table av-1hhgpzp91-057b81c652d7043c8a67e73a86a7bef1 sc-av_one_third av-equal-height-column-flextable perfmatters-lazy-css-bg entered ${
                        isSticky ? "is-sticky" : ""
                      }`}
                      data-ll-status="entered"
                    >
                      <div className="flex_column flex_column-1">
                        <div
                          className="avia-image-container av-1he8fbjbp-0cf86f71654e30597411a01aad8ccfb8 av-styling- avia-align-center avia-builder-el-4 el_before_av_heading avia-builder-el-first "
                          itemProp="image"
                          itemScope="itemscope"
                          itemType="https://schema.org/ImageObject"
                        >
                          <div className="avia-image-container-inner">
                            <div className="avia-image-overlay-wrap">
                              <img
                                className="wp-image-113764 avia-img-lazy-loading-not-113764 avia_image  no-lazy"
                                src="/assets/images/features.svg"
                                alt="features"
                                height={32}
                                width={32}
                                itemProp="thumbnailUrl"
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="av-special-heading av-5bmmvoid-ed8791cfbfa0c44ad73f8ac5f6b67198 av-special-heading-h3 blockquote modern-quote avia-builder-el-5 el_after_av_image el_before_av_codeblock ">
                          <h3
                            style={{ color: "black" }}
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Features
                          </h3>
                          <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div>
                        </div>
                        <br />
                        <section className="avia_codeblock_section avia_code_block_0 margin-bm">
                          <div
                            className="avia_codeblock expend-all-section"
                            itemProp="text"
                            style={{
                              minHeight: "100px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div className="line">
                              <label>
                                <input
                                  type="checkbox"
                                  className="my-checkbox"
                                  defaultValue={1}
                                  onClick={handleExpand}
                                />
                                Expand all
                              </label>
                            </div>
                          </div>
                        </section>
                        <p />
                      </div>
                      <div className="flex_column av-1h6jbtql1-e15deca6572a2dbef3695fc2538487e3 av_one_third avia-builder-el-7 el_after_av_one_third el_before_av_one_third box-style second no_margin flex_column_table_cell av-equal-height-column av-align-bottom column-top-margin">
                        <p />
                        <div
                          className="avia-image-container av-1h1h9cnth-3b489c108f5283cb5a7ca0d1439fac3e av-styling- avia-align-center avia-builder-el-8 el_before_av_heading avia-builder-el-first "
                          itemProp="image"
                          itemScope="itemscope"
                          itemType="https://schema.org/ImageObject"
                        >
                          <div className="avia-image-container-inner">
                            <div className="avia-image-overlay-wrap">
                              <img
                                className="wp-image-113761 avia-img-lazy-loading-not-113761 avia_image  no-lazy"
                                src="/assets/images/pro-new.svg"
                                alt="pro-new"
                                height={28}
                                width={38}
                                itemProp="thumbnailUrl"
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="av-special-heading av-1gw4vd3kl-99f3be4bf5a174ae6d46619f8770d4f7 av-special-heading-h3 blockquote modern-quote avia-builder-el-9 el_after_av_image el_before_av_codeblock ">
                          <h3
                            style={{
                              color: "black",
                              fontWeight: "semibold",
                            }}
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Business
                          </h3>
                          <div className="av-subheading av-subheading_below">
                            <p>
                              Essential tools for streamlined sales management
                            </p>
                          </div>
                          <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div>
                        </div>
                        <br />
                        <section
                          className="avia_codeblock_section avia_code_block_1"
                          itemScope="itemscope"
                          itemType="https://schema.org/CreativeWork"
                        >
                          <div
                            className="avia_codeblock price-section"
                            itemProp="text"
                          >
                            <div className="price-item">
                              <div className="price-item-left">
                                <span className="currency"> ₹</span>2499/-
                              </div>
                              <div className="price-item-right">
                                <span className="billing-type-l">
                                  0-5 user/month
                                </span>
                                <span className="billing-type-r">
                                  Billed Annually
                                </span>
                              </div>
                            </div>
                            <div className="avia-button-wrap av-1jbyr5wkv-2ae0bd940d211da700b172b8db3a06cb-wrap avia-button-center avia-builder-el-25 el_after_av_codeblock avia-builder-el-last price-link transparent">
                              {" "}
                              <a
                                onClick={() => navigate("/sign-up")}
                                plan-type="pro"
                                total-price="2,500"
                                page-name="sales"
                                className="avia-button av-1jbyr5wkv-2ae0bd940d211da700b172b8db3a06cb av-link-btn avia-icon_select-no avia-size-large avia-position-center avia-color-theme-color pages-demo-2 pages-demo-3 get-price pages-demo-0"
                                aria-label="Let's Talk"
                                data-faitracker-click-bind="true"
                              >
                                <span className="avia_iconbox_title">
                                  Let's Talk
                                </span>
                              </a>
                            </div>
                          </div>
                        </section>
                        <p />
                      </div>
                      <div className="flex_column av-1gjm4fuz9-85e105f748c34bffb03aa9386b771d92 av_one_third avia-builder-el-11 el_after_av_one_third el_before_av_one_full box-style third no_margin flex_column_table_cell av-equal-height-column av-align-bottom column-top-margin">
                        <p />
                        <div
                          className="avia-image-container av-1gcqp1phx-3a8c1941561e876d6c685a27a38a1aa0 av-styling- avia-align-center avia-builder-el-12 el_before_av_heading avia-builder-el-first "
                          itemProp="image"
                          itemScope="itemscope"
                          itemType="https://schema.org/ImageObject"
                        >
                          <div className="avia-image-container-inner">
                            <div className="avia-image-overlay-wrap">
                              <img
                                className="wp-image-113758 avia-img-lazy-loading-not-113758 avia_image  no-lazy"
                                src="/assets/images/super.svg"
                                alt="super"
                                height={27}
                                width={58}
                                itemProp="thumbnailUrl"
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="av-special-heading av-1gaz7em51-7a65901585c61893eb0e85704bf0fb1e av-special-heading-h3 blockquote modern-quote avia-builder-el-13 el_after_av_image el_before_av_codeblock ">
                          <h3
                            style={{
                              color: "black",
                              fontWeight: "semibold",
                            }}
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Enterprise
                          </h3>
                          <div className="av-subheading av-subheading_below">
                            <p>
                              Comprehensive suite for advanced sales
                              optimization
                            </p>
                          </div>
                          <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div>
                        </div>
                        <br />
                        <section
                          className="avia_codeblock_section avia_code_block_2"
                          itemScope="itemscope"
                          itemType="https://schema.org/CreativeWork"
                        >
                          <div
                            className="avia_codeblock price-section"
                            itemProp="text"
                          >
                            <div className="price-item">
                              <div className="price-item-left">
                                <span className="currency">₹</span>14495/-
                              </div>
                              <div className="price-item-right">
                                <span className="billing-type-l">
                                  0-30 user/month{" "}
                                </span>
                                <span className="billing-type-r">
                                  Billed Annually
                                </span>
                              </div>
                            </div>
                            <div className="avia-button-wrap av-1jbyr5wkv-2ae0bd940d211da700b172b8db3a06cb-wrap avia-button-center avia-builder-el-25 el_after_av_codeblock avia-builder-el-last price-link transparent">
                              {" "}
                              <a
                                onClick={() => navigate("/sign-up")}
                                plan-type="pro"
                                total-price="2,500"
                                page-name="sales"
                                className="avia-button av-1jbyr5wkv-2ae0bd940d211da700b172b8db3a06cb av-link-btn avia-icon_select-no avia-size-large avia-position-center avia-color-theme-color pages-demo-2 pages-demo-3 get-price pages-demo-0"
                                aria-label="Let's Talk"
                                data-faitracker-click-bind="true"
                              >
                                <span className="avia_iconbox_title">
                                  Let's Talk
                                </span>
                              </a>
                            </div>
                          </div>
                        </section>
                        <p />
                      </div>
                    </div>
                    {/* dropdowns section---------------- */}
                    <div
                      style={{
                        position: "relative",
                        top: "0px",
                      }}
                    >
                      <div
                        style={{ position: "sticky", top: "0px" }}
                        className="flex_column av-19jnwtv11-6317ffce0d3b09892bff626609bab4e0 av_one_full avia-builder-el-18 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <div
                          style={{}}
                          onClick={() => setOpenRowLead(!openRowLead)}
                          className="av-special-heading av-m24nz55a-168d7e6b81fbd2d7620d8bba6fda7c82 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-16 el_before_av_table avia-builder-el-first pricing-header first"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Lead / Project / Meetings / Proposal Management
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>

                        <br />
                        <div
                          style={{ display: openRowLead ? "block" : "none" }}
                          className="avia-data-table-wrap av-1frz5jeol-a2fc036b06085322b81bcb8606755e11 avia_scrollable_table avia-table-12"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-17 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">
                                  Automatic Lead Distribution
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Lead Status & Lifecycle Tracking{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Follow-up Management & Alerts
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Response Categorization (Positive/Negative)
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Lead Transfer & Ownership Approval
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Call-Based Follow-Up Logging{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Full Activity Timeline (calls, notes,
                                  meetings){" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Duplicate Lead Validation</td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Centralized Lead Transfer Requests{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Meeting Scheduling & Activity Tracking{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Proposal Management & Document Uploads{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>

                              <tr className="">
                                <td className="">Storage</td>
                                <td className="">20GB</td>
                                <td className="">120GB</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        style={{ position: "sticky", top: "0" }}
                        className="flex_column av-19jnwtv11-6317ffce0d3b09892bff626609bab4e0 av_one_full avia-builder-el-18 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <div
                          onClick={() => setOpenRowSales(!openRowSales)}
                          className="av-special-heading av-19e5ysnit-61d4dc1a2ea782f0b46757e5b00770c8 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-19 el_before_av_table avia-builder-el-first pricing-header"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Sales Management
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>
                        <div
                          style={{ display: openRowSales ? "block" : "none" }}
                          className="avia-data-table-wrap av-198m922ad-99f8debcb3848381202b63efec47ec3d avia_scrollable_table avia-table-2"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-20 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">Smart Sales Dashboards </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Qualify Leads </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Sales Target vs Achievement{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">BD Performance Analytics </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Category & Source-Based Segmentation
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Meeting Type & Schedule Views{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>

                              <tr className="">
                                <td className="">Sales Funnel Tracking</td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Lead Performance Metrics</td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        style={{ position: "sticky", top: "0" }}
                        className="flex_column av-1405wvhp1-2a935fb65873d74f1af0971ae932f4d1 av_one_full avia-builder-el-21 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <p />
                        <div
                          onClick={() => setOpenRowUsers(!openRowUsers)}
                          className="av-special-heading av-13trv7x05-50830700801803d6cfb21bd43c761fa4 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-22 el_before_av_table avia-builder-el-first pricing-header"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            User Management
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>
                        <br />
                        <div
                          style={{ display: openRowUsers ? "block" : "none" }}
                          className="avia-data-table-wrap av-13ta2li39-ea210ac2ac6c6d8252c568a3f49613ce avia_scrollable_table avia-table-3"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-23 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">Centralized Admin Control</td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  User-Based Roles & Permissions
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Account & Password Management{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">User Profile Updates </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  User Transfer & Ownership Reassignment{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  User Activation / Deactivation{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p />
                      </div>
                      <div
                        style={{ position: "sticky", top: "0" }}
                        className="flex_column av-yhjdx0k5-45119cb809a8d06af842259c265e38c7 av_one_full avia-builder-el-24 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <p />
                        <div
                          onClick={() =>
                            setOpenRowAutomation(!openRowAutomation)
                          }
                          className="av-special-heading av-3fn78oid-601ce9845ce6431a77c69d486b2b9576 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-25 el_before_av_table avia-builder-el-first pricing-header"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Processes, Automations and Workflows
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>
                        <br />
                        <div
                          style={{
                            display: openRowAutomation ? "block" : "none",
                          }}
                          className="avia-data-table-wrap av-yao8n8d1-f4cf01e3a275c77b3ba332f6ed0ef13f avia_scrollable_table avia-table-4"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-26 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">
                                  Task & Follow-up Automation{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Rule-Based Lead Assignment{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Approval Workflows </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">API Integrations </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p />
                      </div>
                      <div
                        style={{ position: "sticky", top: "0" }}
                        className="flex_column av-vj63sdxx-9f3b0eb20267dce6afac66612434e4ec av_one_full avia-builder-el-27 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <p />
                        <div
                          onClick={() => setOpenRowReport(!openRowReport)}
                          className="av-special-heading av-vgtpldxx-ac98b104be5dee51f597bcef95fe3d35 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-28 el_before_av_table avia-builder-el-first pricing-header"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Reporting & Analytics
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>
                        <br />
                        <div
                          style={{ display: openRowReport ? "block" : "none" }}
                          className="avia-data-table-wrap av-vczgv09h-d698ee57fadd9d018f55e4311b65e01a avia_scrollable_table avia-table-5"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-29 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">Lead & Deal Reports </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Real-time Sales Dashboards</td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Pipeline Reports </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Activity Reports (Calls, Meetings, Tasks){" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Target vs Achievement Reports{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">Proposal Status Reports </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p />
                      </div>

                      <div
                        style={{ position: "sticky", top: "0" }}
                        className="flex_column av-fovu0qfp-f6124ea23efc16c1884d80fb652f2adb av_one_full avia-builder-el-36 el_after_av_one_full el_before_av_one_full margin-top-unset price-toggle first flex_column_div column-top-margin"
                      >
                        <p />
                        <div
                          onClick={() => setOpenRowMobCrm(!openRowMobCrm)}
                          className="av-special-heading av-fh2bk76d-da805825727c755f6d08655df3aa39e0 av-special-heading-h3 blockquote1 modern-quote avia-builder-el-37 el_before_av_table avia-builder-el-first pricing-header"
                        >
                          <h3
                            className="av-special-heading-tag "
                            itemProp="headline"
                          >
                            Mobile CRM
                          </h3>
                          {/* <div className="special-heading-border">
                            <div className="special-heading-inner-border" />
                          </div> */}
                        </div>
                        <br />
                        <div
                          style={{ display: openRowMobCrm ? "block" : "none" }}
                          className="avia-data-table-wrap av-fe5zxv85-b74ccca8664e7c35e9311dff8a2bc7d1 avia_scrollable_table avia-table-8"
                        >
                          <table
                            className="avia-table avia-data-table avia_pricing_default avia-builder-el-38 el_after_av_heading avia-builder-el-last "
                            itemScope="itemscope"
                            itemType="https://schema.org/Table"
                          >
                            <tbody>
                              <tr className="">
                                <td className="">
                                  Leads, Activities & Tasks on Mobile
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Full CRM Mobile App Access (Android/iOS){" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Mobile Dashboards & Notifications{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Live Pipeline & Performance Charts{" "}
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                              <tr className="">
                                <td className="">
                                  Real-Time Sync with Web CRM
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                                <td className="">
                                  <img
                                    className="price-check no-lazy"
                                    src="/assets/images/check.svg"
                                    alt="check"
                                    style={{ width: 26 }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p />
                      </div>
                    </div>

                    <div className="flex_column av-m3wwatvi-678d9633e722de1b81a517d214fb1a4f av_one_full avia-builder-el-39 el_after_av_one_full avia-builder-el-last full-astrick first flex_column_div column-top-margin">
                      <section
                        className="av_textblock_section av-m3wvty9z-cafc9264e1791975c3c49c047e1b719c"
                        itemScope="itemscope"
                        itemType="https://schema.org/CreativeWork"
                        lottieurl=""
                        imageurl=""
                      >
                        <div className="avia_textblock" itemProp="text">
                          <p>
                            <span className="full-astrick">*</span>
                            Available as an optional add-on
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </main>
              <div className="pricing-sec-box">
                <div className="container2">
                  <div className="pricing-sec-box-inner">
                    <div
                      style={{
                        display: "flex",
                        // alignItems: "center",
                        // justifyContent: "space-between",
                        gap: "2rem",
                      }}
                      className="top-box"
                    >
                      <h2>Unsure Which Plan Works Best for You?</h2>
                      <button onClick={() => navigate("/sign-up")}>
                        Let's Talk
                      </button>
                    </div>
                    {/* <div className="bottom-box">
                      <div className="bottom-text">
                        <h3>Special Pricing for Select Startups*</h3>
                        <p>(Terms and conditions apply)</p>
                      </div>
                      <button onClick={() => navigate("/sign-up")}>
                        See if You Qualify
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* close content main element */}
            </div>
            <hr />
          </div>
        </div>
      </div>
    </>
  );
}

export default NewPricing;
